import {BasicSymbol, SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class LTSymbol extends BasicSymbol {

    private _ltlightSpine: PIXI.spine.Spine;
    private _lightLoopTl: gsap.core.Timeline;
    private _symTl: gsap.core.Timeline;


    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {

        symbolName = "LT";
        super(symbolName, initState, reel, symbolPosition);
        this.load();
        this.getStateAnimation(initState);
        this._lightLoopTl = gsap.timeline();
        this._symTl = gsap.timeline();

    }

    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        let tl: gsap.core.Timeline = gsap.timeline();

        switch (state) {
            case SymbolStates.LANDING:
                tl.add(() => {
                    this.state = state;
                    this.moveToLockOverlayLayer()
                }, 0);
                if(this._symTl.isActive()){
                    this._symTl.totalProgress(1);
                }
                tl.add(this.landingAnim(), 0);
                this._symTl = tl;
                break;
            case SymbolStates.NO_WIN:
                tl.add(() => {
                    this.state = state;
                    this.mainSprite.tint = 0x414655;
                    this.mainSpine!.tint = 0x414655;
                }, 0);
                break;
            case SymbolStates.WIN:
                tl.add(() => {
                    this.state = state;
                }, 0);
                break;
            case SymbolStates.SPIN:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.setSpriteTexture("_spin");
                this.moveToNormalLayer();
                break;
            case SymbolStates.START_SPIN:
                tl.add(() => {
                    this.state = state;
                    this.mainSpine!.visible = false;
                }, 0);
                this.moveToNormalLayer();
                break;
            case SymbolStates.REVEAL:
                tl.add(() => {
                    this.state = state;
                    this.moveToLockOverlayLayer();
                }, 0);
                if(this._symTl.isActive()){
                    this._symTl.totalProgress(1);
                }
                tl.add(this.revealAnim());
                this._symTl = tl;
                break;
            case SymbolStates.REMOVED:
                tl.add(() => {
                    this.state = state;
                }, 0);
                if(this._symTl.isActive()){
                    this._symTl.totalProgress(1);
                }
                tl.add(this.waitAnim(), 0);
                this._symTl = tl;
                break;
            case SymbolStates.SCALED:
                break;
            case SymbolStates.SPLIT:
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.STICKY:
                tl.add(() => {
                    this.state = state;
                    this.isOldSym = true;
                    this.moveToLockOverlayLayer();
                }, 0);
                break;
            case SymbolStates.UNSTICKY:
                break;
            default:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.moveToNormalLayer();
                this.setSpriteTexture("");
        }

        return tl;
    }


    public setSpinePos(isRespinStart: boolean): void {//use after setting it back to normal layer
        this.mainSprite.position.y = 300;
    }

    public playLTLightSpineAnimation(animName: string | null, toLoop: boolean, restore: boolean = false): gsap.core.Timeline {
        const flashTl: gsap.core.Timeline = gsap.timeline();
        flashTl.add(() => {
            this._ltlightSpine.visible = true;
            if (animName === null) {
                this._ltlightSpine.position.x = -28;
                this._ltlightSpine.position.y = 0;
                this.mainSprite.addChild(this._ltlightSpine);
            } else {
                this._ltlightSpine.position.x = 46;
                this.symID === 0 ? this._ltlightSpine.position.y = 300 : this.symID === 1 ? this._ltlightSpine.position.y = 100 : this._ltlightSpine.position.y = -100;
                this.view.addChild(this._ltlightSpine);
            }
        });
        if (!toLoop) {
            flashTl.add(SpineGSAPWrapper.createTimelineForAnimation(this._ltlightSpine, 0, "LootLightLoop", toLoop).timeScale(100), 0);
            flashTl.add(SpineGSAPWrapper.createTimelineForAnimation(this._ltlightSpine, 0, "LootLightOff", false), "<");
            flashTl.add(XwaysHoarder2.reelView.hideRespinOverlay(0.5), "<0.3");
        } else {
            flashTl.add(SpineGSAPWrapper.createTimelineForAnimation(this._ltlightSpine, 0, "LootLightOff", false).reverse(), 0);
            flashTl.add(XwaysHoarder2.reelView.showRespinOverlay(0.5), 0.4);
            flashTl.add(() => {
                this._ltlightSpine.autoUpdate = true;
                this._ltlightSpine.state.update(1);
                this._ltlightSpine.state.setAnimation(0, "LootLightLoop", true).timeScale = 1;
            }, 0.94);
            flashTl.to(this, {duration: SpineGSAPWrapper.animationTimeDuration(this._ltlightSpine, "LootLightLoop")}, "<")
            if (!restore) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.RESPIN_ALARM);
            }
        }
        return flashTl;
    }

    public restoreCase(): gsap.core.Timeline {
        const resTl: gsap.core.Timeline = gsap.timeline();
        let animString: string = "LootReveal";
        this.symID === 0 ? animString += "_Top" : this.symID === 1 ? animString += "_Mid" : animString += "_Bot";
        resTl.to(this.mainSprite, {alpha: 0, duration: 0.001}, 0);
        resTl.add(() => {
            this.mainSpine!.visible = true;
        }, 0.005);
        resTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, animString, false), 0);
        resTl.add(() => {
            this.symID = 0;
            this.setFullSpriteTexturetoLT();
        }, 0.7);
        resTl.add(() => {
            this.mainSpine!.visible = false;
            this.position.y = 0;
            this.mainSprite.alpha = 1;
            this.setSpinePos(true);
        }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, animString));
        resTl.add(this.playLTLightSpineAnimation(animString, true), SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, animString));
        resTl.add(this.getStateAnimation(SymbolStates.STICKY));
        return resTl;
    }

    private setFullSpriteTexturetoLT(): void {
        this.mainSprite.texture = XwaysHoarder2.assetLoader.getTextures("LT/LT_parts/lootBgFull")[0];
        this.mainSprite.visible = true;
    }

    private setSpine(): void {
        this.mainSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.LOOT_RESPIN));
        this.mainSpine.visible = false;
        this.mainSpine.name = "lootRespinSpine";
        this.mainSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.mainSpine);
        this._ltlightSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.LOOT_LIGHT));
        this._ltlightSpine.visible = false;
        this._ltlightSpine.name = "redlight";
        this.view.addChild(this._ltlightSpine);

    }

    private load(): void {
        this.mainSprite.name = "fullLTSprite";
        this.mainSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.mainSprite.anchor.set(0.5, 0.5);
        this.mainSpriteContainer.addChild(this.mainSprite);

        this.view.addChild(this.mainSpriteContainer);
        this.setSpine();
        this.view.addChild(this.overlayContainer);
        this.visualHeightStatus = 200;
        this.isSticky = false;
        this.isOldSym = false; //doesnt matter in restore
        this.symbolHeight = 1;//no of space it fills in terms of symbol count in a reel
        this.splitAnimOn = false;
        this.isSplitted = false;
        this.symbolSize = 1;//multiplier counter
        this.noWinOverlay = null; //create according to size

    }

    private revealAnim(): gsap.core.Timeline {
        const revealTl: gsap.core.Timeline = gsap.timeline();
        let animString: string = "LootReveal";
        this.symID === 0 ? animString += "_Top" : this.symID === 1 ? animString += "_Mid" : animString += "_Bot";
        revealTl.add(() => {
            this.mainSprite.tint = 0xffffff;
            this.mainSpine!.tint = 0xffffff;
        });
        revealTl.to(this.mainSprite, {alpha: 0, duration: 0.001}, 0);
        revealTl.add(() => {
            this.mainSpine!.visible = true;
        }, 0.005);
        revealTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, animString, false), 0);
        revealTl.add(() => {
            XwaysHoarder2.reelView.reels[0].lockSpecialSymAndAddDummyBelow(this.symID, "D", false);
            this.symID = 0;
            this.setFullSpriteTexturetoLT();
        }, 0.7);
        revealTl.add(() => {
            this.mainSpine!.visible = false;
            this.position.y = 0;
            this.mainSprite.alpha = 1;
            this.setSpinePos(true);
        }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, animString));
        revealTl.add(this.playLTLightSpineAnimation(animString, true), SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, animString));
        revealTl.add(this.getStateAnimation(SymbolStates.STICKY));
        return revealTl;
    }

    private landingAnim(): gsap.core.Timeline {
        const landTl: gsap.core.Timeline = gsap.timeline();
        landTl.to(this.mainSprite, {alpha: 0, duration: 0.001}, 0);
        landTl.add(XwaysHoarder2.screenShake(0.4, 90, false, 15), 0);
        landTl.add(() => {
            this.mainSpine!.visible = true;
        }, 0.005);
        landTl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.RESPIN_SYMBOL_LANDING);
        }, 0);
        landTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "LootAttention", false), 0);
        landTl.add(() => {
            this.mainSprite.texture = XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath("LT", "_reveal"))[0];
            this.mainSprite.position.y = 80;
        }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "LootAttention"));
        /*   landTl.to(this.mainSprite, {
               alpha: 1,
               duration: 0.001
           }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "LootAttention"));*/
        landTl.add(() => {
            this.mainSpine!.autoUpdate = true;
            this.mainSpine!.state.setAnimation(0, "LootFeatureWait", true);
        }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "LootAttention"));
        landTl.add(() => {
            this._lightLoopTl.add(XwaysHoarder2.reelView.showRespinOverlay(0.35));
            this._lightLoopTl.add(XwaysHoarder2.reelView.hideRespinOverlay(0.35));
            this._lightLoopTl.repeat(30);
        }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "LootAttention"))

        return landTl;
    }

    private waitAnim(): gsap.core.Timeline {
        const waitTL: gsap.core.Timeline = gsap.timeline();
        waitTL.to(this.mainSprite, {alpha: 1, duration: 0.001}, 0);
        waitTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "LootFeatureWait", false).timeScale(200), 0);
        this._lightLoopTl.kill();
        waitTL.add(()=>{
            this.moveToNormalLayer();
        },">");
        XwaysHoarder2.reelView.hideRespinOverlay(0.01);
        return waitTL;
    }
}